import sit_0 from './compass/pt-BR/sit.json';

export const EXTRA_LOCALES = {
    'pt-BR': {sit: sit_0},
};
